import type { FC } from 'react';

import { Menu } from '@mantine/core';

import { FiltersDropdown } from 'components/component-overview/components/FiltersDropdown';
import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import type { InlineFiltersProps } from 'components/component-overview/inline-filters/InlineFilters';
import { SearchService } from 'components/component-overview/services/SearchService';
import { InlineFiltersMoreButton as Component } from 'components/inline-filters/InlineFilters.MoreButton';

const InlineFiltersMoreButton: FC<Pick<InlineFiltersProps, 'hideFilters'>> = ({ hideFilters }) => {
    const filters = useComponentSearchFilters();

    const showClearButton = !SearchService.isInitialSearch(filters);

    return (
        <Component
            showClearButton={showClearButton}
            onClear={() => SearchService.resetFilters()}
            MoreFilters={
                <>
                    <Menu.Label>Filters</Menu.Label>
                    <FiltersDropdown hideFilters={hideFilters} />
                </>
            }
        />
    );
};

export { InlineFiltersMoreButton };
